import React from "react";
import { TabItem } from "../Tabs/types";
import { BannerBgColor, BannerWrapperSize } from "../Banner/types";
import Banner from "../Banner";
import { Typography } from "../Typography";
import { Tabs } from "../Tabs";

export const FaqsModule = ({
  data,
  wrapperSize,
  backgroundColor,
  customClass,
}: {
  data: { title: string; faqsHomeTabs: TabItem[] };
  wrapperSize: BannerWrapperSize;
  backgroundColor: BannerBgColor;
  customClass?: string;
}) => {
  const { title, faqsHomeTabs } = data;

  return (
    <Banner
      big
      customBgColor={backgroundColor}
      wrapperSize={wrapperSize}
      customClass={customClass}
    >
      <Typography Tag={"h2"} spacing={8}>
        {title}
      </Typography>
      <Tabs tabsData={faqsHomeTabs} />
    </Banner>
  );
};
